import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, Col, Dropdown } from "react-bootstrap";
import { FiHome, FiGrid, FiList, FiDownload, FiPlus } from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import AddProjectModal from "../modals/projects/AddProjectModal";

const ProjectHeader = ({ openModal }) => {
  const location = useLocation();
const [show, setShow] = useState(false);
  return (
    <div  style={{ padding: "15px", background: "#f8f9fa",  }}
 className=" d-flex justify-content-between">

      {/* LEFT */}
    <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Projects</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                    Projects
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Projects</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      {/* RIGHT */}
      <div className="d-flex align-items-center flex-wrap gap-2">

        {/* LIST / GRID */}
        <div className="view-switch">
          <Link
            to="/project-list"
            className={`icon-btn ${location.pathname === "/project-list" ? "active" : ""}`}
          >
            <FiList />
          </Link>

          <Link
            to="/project-grid"
            className={`icon-btn ${location.pathname === "/project-grid" ? "active" : ""}`}
          >
            <FiGrid />
          </Link>
        </div>

        {/* EXPORT */}
        <Dropdown>
          <Dropdown.Toggle className="btn-white text-dark">
            <FiDownload className="me-1" /> Export
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
<AddProjectModal show={show} handleClose={() => setShow(false)} />
        {/* ADD PROJECT */}
        <button className="btn-orange"  onClick={() => setShow(true)}>
          <FiPlus className="me-1" /> Add Project
        </button>

      </div>
      <style>
          {
               `
               /* HEADER */
.page-breadcrumb h2 {
  font-weight: 600;
}

/* VIEW SWITCH */
.view-switch {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 3px;
  background: #fff;
}

.icon-btn {
  padding: 6px 10px;
  color: #333;
}

.icon-btn.active {
  background: #ff6b1a;
  color: #fff;
  border-radius: 6px;
}

/* BUTTON */
.btn-orange {
  background: #ff6b1a;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
}

/* EXPORT */
.btn-white {
  background: #fff !important;
  border: 1px solid #ddd !important;
}

/* TABS */
.custom-tabs .nav-link.active {
  color: #ff6b1a !important;
  border-bottom: 2px solid #ff6b1a !important;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
    gap: 10px;
  }
}`
          }
      </style>
    </div>
  );
};

export default ProjectHeader;